export default __webpack_public_path__ + "static/media/Alca-avatar.b75acf4e.jpg";